import { render, staticRenderFns } from "./MonatsabschlussUebersicht.vue?vue&type=template&id=68956db8&"
import script from "./MonatsabschlussUebersicht.vue?vue&type=script&lang=ts&"
export * from "./MonatsabschlussUebersicht.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports